(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/top-app-bar", [], factory);
	else if(typeof exports === 'object')
		exports["top-app-bar"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["top-app-bar"] = factory();
})(this, function() {
return 